import React, { useMemo } from "react"
import { baseUrlImg } from "../../config/api"
import { bech32 } from "bech32"
import moment from "moment"

const AztecoTicket = ({ arr }) => {
  const receiptData = useMemo(() => {
    try {
      return arr.receipt ? JSON.parse(arr.receipt) : {}
    } catch {
      return {}
    }
  }, [arr.receipt])

  const decodeLnurl = (lnurl) => {
    try {
      const decoded = bech32.decode(lnurl.toLowerCase(), 1500)
      const bytes = bech32.fromWords(decoded.words)
      return new TextDecoder().decode(Uint8Array.from(bytes))
    } catch {
      return null
    }
  }

  const decodedLnurl = useMemo(() => {
    if (!receiptData.lnurl) return null
    return decodeLnurl(receiptData.lnurl)
  }, [receiptData.lnurl])

  return (
    <div>
      <div className="json_spedizionepro">
        <div
          className="d-flex justify-content-center mb-4"
          style={{ border: "unset" }}
        >
          {<img src={`${baseUrlImg}/${arr.logo}`} alt="service logo" height={35} />}
        </div>

        <div style={{ paddingTop: 10 }}>
          Order ID: <span>{receiptData.order_id || "-"}</span>
        </div>
        <div style={{ paddingTop: 10 }}>
          Data/Ora:
          <span> {moment(arr?.created_at).format("DD/MM/YYYY HH:mm:ss")}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Voucher Code: <span>{receiptData.voucher_code || "-"}</span>
        </div>
        <div style={{ paddingTop: 10 }}>
          Reference Code: <span>{receiptData.reference_code || "-"}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Currency: <span>{receiptData.currency || "-"}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Total:{" "}
          <span>
            {receiptData.total || "-"} {receiptData.currency}
          </span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Purchase amount: <span>{receiptData.purchase_amount || "-"}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Commission: <span>{receiptData.commission || "-"}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Bitcoin: <span>{receiptData.bitcoin || "-"}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Network fee: <span>{receiptData.network_fee || "-"}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          BTC price: <span>{receiptData.bitcoin_price || "-"}</span>
        </div>
      </div>

      {receiptData.lnurl && (
        <div
          style={{
            width: "100%",
            wordBreak: "break-word",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=lightning:${receiptData.lnurl}`}
            alt="Lightning LNURL QR"
            style={{
              margin: "20px 0",
            }}
          />

          <span
            style={{
              fontSize: "12px",
              textAlign: "center",
              color: "#6b7280",
              marginBottom: "8px",
            }}
          >
            Scansiona con un wallet Lightning per ricevere Bitcoin
          </span>

          {decodedLnurl && (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={decodedLnurl}
              style={{
                fontSize: "11px",
                textAlign: "center",
                backgroundColor: "#eff6ff",
                padding: "8px",
                borderRadius: "6px",
                width: "100%",
                color: "#1d4ed8",
                textDecoration: "none",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#dbeafe"
                e.currentTarget.style.textDecoration = "underline"
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#eff6ff"
                e.currentTarget.style.textDecoration = "none"
              }}
            >
              {decodedLnurl}
            </a>
          )}
        </div>
      )}
    </div>
  )
}

export default AztecoTicket
